export enum AllocationUsageMethod {
  Percentage = 'Percentage',
  Actual = 'Actual',
  AsIs = 'As Is',
}
